import { useQuery } from "@tanstack/react-query";
import { publicListsService, type PublicListSource } from "../services/public-lists.service";

export const usePublicList = (source: PublicListSource) =>
  useQuery({
    queryKey: ["public-list", "token" in source ? `token:${source.token}` : `id:${source.id}`],
    queryFn: () => publicListsService.get(source),
    staleTime: 10 * 60 * 1000,
    retry: (count, error) => !/not found/i.test(error.message) && count < 2,
  });
